/**
 * Client-only SPA bootstrap for the Firebase Hosting test deploy.
 *
 * This entry is used only by `vite.firebase.config.ts` / `npm run build:firebase`.
 * The default dev server and Cloudflare SSR build continue to use TanStack
 * Start's server entry (`@tanstack/react-start/server-entry`) and do not
 * touch this file.
 *
 * Providers (QueryClientProvider + AuthProvider) live on the root route
 * (`src/routes/__root.tsx`), so this entry intentionally does NOT wrap them
 * again — doing so would mount duplicate auth listeners.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";
import "./styles.css";

const router = createRouter({
  routeTree,
  context: {},
  scrollRestoration: true,
  defaultPreloadStaleTime: 0,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById("root");
if (!container) {
  throw new Error('[main] Missing <div id="root" /> in index.html');
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
